export default function processAjaxResponse(response, successCallback, errorCallback) {
    
    if (response && response.result && response.result == "success") {
        successCallback(response.msg, response);
    } else {
        let msg = "";
        let data = null;

        if (response && response.error) {
            if (response.error.toString) {
                msg = response.error.toString();
            } else {
                msg = "" + response.error;
            }
        } else {
            msg = "Произошла ошибка";
        }

        if (response && response.data) {
            data = response.data;
        }

        errorCallback(msg, data);
    }
}